import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=77e70b70&scoped=true"
import script from "./GuestBox.vue?vue&type=script&lang=js"
export * from "./GuestBox.vue?vue&type=script&lang=js"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=77e70b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e70b70",
  null
  
)

export default component.exports